import { ClienteDashboardResponse } from "../typings";
import axios from "infra/http";
import { useQuery } from "react-query";

function useDashboardClientes() {
  return useQuery(
    `/v1/cliente/dashboard`,
    async () => {
      const res = await axios.get<ClienteDashboardResponse>('/v1/cliente/dashboard');

      return res.data;
    },
  );
}

export default useDashboardClientes;
